export default () => [
    {
        title: "What is patient financing?",
        facts: [
            "Patient financing allows you to borrow money from a lender to pay for your dental treatment costs.  Multiple types of loans or lines of credit may be available.  An installment loan typically has a fixed term, a fixed interest rate, and a regular monthly payment schedule.  A revolving loan or credit card typically has an open term, can be used for repeated transactions, and monthly payments could vary based on transaction amounts and usage frequency.",
        ],
    },
    {
        title: "What are credit inquiries?",
        facts: [
            "Anytime you apply for credit, including patient financing, your credit report may be pulled (a credit inquiry). These inquiries allow companies and financial institutions to view your credit history and score to determine your creditworthiness. There are two kinds of credit inquiries: “hard” pulls and “soft” pulls, both of which have a different impact on your credit score.",
        ],
    },
    {
        title: 'What is a "soft" pull? ',
        facts: [
            "A “soft” pull is a view of your credit report that does not require your authorization and the company viewing it is provided limited information. A soft pull won't affect your credit score. A soft credit inquiry may be used when a company prequalifies you for a credit offer.",
        ],
    },

    {
        title: "What is a hard pull?",
        facts: [
            "Most lenders or their agents do a “hard” credit pull before making a final decision on an application for credit. A hard pull impacts your credit score, and can stay on your report for up to two years.  Too many hard pulls in a short time frame may signal to a company that you are applying for credit you may not be able to pay back.   You can see the names of companies who have recently pulled your credit in the credit inquiries section of your credit report.",
        ],
    },

    {
        title: "Will a prequalification affect my credit score?",
        facts: [
            "A prequalification has no impact to your credit score because a soft pull is used. A hard pull that could impact your score will only occur if you continue with your credit application.",
        ],
    },
    {
        title: "Who is my patient financing loan with?",
        facts: [
            "As a borrower, you'll receive a credit agreement that identifies the company that is funding your patient financing. This agreement is between you and the funding company directly.",
        ],
    },
    {
        title: "What if I don't want to use my patient financing loan?",
        facts: [
            "The application and approval processes establish a loan or line of credit for qualified borrowers. If you are approved for patient financing, you have no obligation on the loan or line of credit until and unless you use it to pay for a transaction. If you do not want to use your loan or line of credit, you may close your account at any time before you authorize a transaction.",
        ],
    },
    {
        title: 'What is a "deferred interest" loan?  Do I have a 0 interest loan? ',
        facts: [
            "Patient financing with deferred interest includes a 'Promotional Period' which is shown in the Truth in Lending disclosures of the credit agreement. This period typically ranges from six (6) to eighteen (18) months, but can vary. During the Promotional Period, interest accrues on the account, but it is waived if the purchase balance is paid in full prior to the end of the Promotional Period.",
            "If you do not repay the entire purchase balance before the end of the Promotional Period, you will be responsible for repaying all interest that accrued on your account during the Promotional Period, and any future interest that is subsequently billed to your account.",
        ],
    },
    {
        title: "How much is my payment? ",
        facts: [
            "Your payment is set by the terms and conditions of your patient financing agreement and depends on the type of financing you choose and the amount of your transaction(s).  Before using a loan or credit card to finance treatment, you should review the payment terms carefully and consider whether payments are affordable for you.",
            "Each billing statement will identify the transactions on your account, the interest that is being billed to your account, the principal balance, and actual minimum monthly payment due for that billing cycle.",
        ],
        subFacts: [
            {
                title: "Installment loan payments",
                description:
                    "An installment loan agreement includes a repayment schedule showing the amount of each payment.  The lender may also provide monthly statements informing you of the payment that is due.",
            },
            {
                title: "Revolving_loan or credit card payments",
                description:
                    "A revolving loan or credit card agreement will specify how minimum monthly payments are calculated.  Payment amounts can vary as they are typically a percentage of the previous statement’s balance, and payments can continue indefinitely as long as there is a balance on the account.  A billing statement will contain transactions (on the next statement after the transactions occur), interest billed to the account, the minimum monthly payment for that billing cycle, and an estimated repayment schedule based on the minimum monthly payment calculation and that particular statement’s balance.",
            },
        ],
    },
    {
        title: "What is a co-borrower? ",
        facts: [
            "A co-borrower is any additional borrower who is obligated on the credit agreement and whose income and credit history are used to qualify for the loan.",
        ],
    },
    {
        title: "Will I qualify for a patient financing loan?",
        facts: [
            "Lenders establish different credit criteria for their loans or lines of credit.  They review your credit score, existing credit obligations, income, requested loan amount, and other information to make a decision.  If you are approved, you should review the terms of the offer carefully and decide whether you are able to afford to pay back the treatment amount and any interest and fees associated with the patient financing. If you are not approved, you may wish to explore other sources of financing your treatment, such as borrowing money from family or friends.",
        ],
    },
]
